import React, { useState } from "react";
import { toast } from "react-toastify";
import dataService from "../../../../../helpers/dataService";
import Control from "../../../../common/Controls/Control";
import SaveBtn from "../../../../common/SaveBtn";
import "./askdocument.scss";
const AskDocument = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [document, setDocument] = useState("");

  const save = () => {
    if (isSaving) return false;
    setIsSaving(true);
    dataService.post(
      `feedbacks`,
      {
        documentName: document,
      },
      (datas) => {
        setIsOpen(false);
        setDocument("");
        toast.success(
          "Votre demande a bien été reçue, merci de votre retour !"
        );
      },
      (err) => {},
      () => setIsSaving(false)
    );
  };

  return (
    <div className={`ask-doc border ${isOpen ? "open" : ""}`}>
      <div
        className={`d-flex w-100 align-items-center ${
          isOpen ? "justify-content-end" : "justify-content-center"
        }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <i
          className={`cursor-pointer fa ${
            isOpen ? "fa-times text-dark " : "fa-question text-secondary "
          }`}
        />
      </div>
      <div className={`ask-content`}>
        <strong>Besoin de télécharger d'autres documents ?</strong>
        <p className="my-1">
          Afin d'améliorer nos services, faites-nous savoir quels documents vous
          souhaiteriez ajouter à vos coffres-forts.
        </p>
        <div>
          <input
            className="w-100 border mt-2 p-2"
            placeholder="Quel document souhaitez-vous ajouter ?"
            type="text"
            value={document}
            onChange={(e) => setDocument(e.target.value)}
          />
        </div>

        <div className="d-flex align-items-end justify-content-end">
          <SaveBtn
            type="secondary"
            save={save}
            isSaving={isSaving}
            className="btn-sm"
          />
        </div>
      </div>
    </div>
  );
};

export default AskDocument;
